module.exports = __webpack_public_path__ + "static/media/loading.6e5d6096.gif";